export class Point {
  constructor (
    x,
    y
  ) {
    this.x = x;
    this.y = y;
  }
}

export class BoundingBox {
  constructor(
    upperLeftCorner,
    lowerRightCorner
  ) {
    this.upperLeftCorner = upperLeftCorner;
    this.lowerRightCorner = lowerRightCorner;
  }
}

export class Polygon {
  constructor (
    points,
    closedShape
  ) {
    this.points = points;
    this.closedShape = closedShape;
  }
}

export class FloorplanWall {
  constructor(
    layer,
    points,
    sectionId) {
      this.layer = layer;
      this.points = points;
      this.sectionId = sectionId;

      this.itemType = "FloorplanWall";
    }
}

export class RegularTable {
  constructor(
    tableId,
    seatCount,
    location,
    rotation,
    shape) {
      this.tableId = tableId;
      this.seatCount = seatCount;
      this.location = location;
      this.rotation = rotation;
      this.shape = shape;

      this.itemType = "RegularTable";
    }
}

export class FloorplanIconType {
    Kitchen = 1;
    RestroomMen = 2;
    RestroomWomen = 3;
    RestroomDisabled = 4;
    RestroomUnisex = 5;
    Wardrobe = 6;
    Bar = 7;
    DanceFloor = 8;
    Stairs = 9;
    Exit = 10;
    Window = 11;
    Door1 = 12;
    Door2 = 13;
}

export class FloorplanObject {
  constructor(
    icon,
    location,
    scale,
    rotation) {

      this.icon = {icon, scale, location, rotation},
      this.itemType = "FloorplanObject";
    }
}

export class TableShape {
  Rectangular = 1;
  Round = 2;
}

export class FloorplanTable {
  constructor(
    tableId,
    seatCount,
    location,
    rotation,
    hidden
  ) {
    this.tableId = tableId;
    this.seatCount = seatCount;
    this.location = location;
    this.rotation = rotation;
    this.layer = 3;
    this.shape = TableShape.Rectangular;
    this.itemType = 'RegularTable';
    this.hidden = hidden;
  }
}

export class FloorplanLabel {
  constructor(
    location,
    rotation,
    text,
    fontSize
  ) {
    this.itemType = "FloorplanLabel";
    this.location = location;
    this.rotation = rotation;
    this.label = {
      text: text,
      fontSize: fontSize
    }
  }
}


export class Floorplan {
  constructor(
    entities, tables) {
      this.entities = entities;
      this.tables = tables;
    }
}
